import { request } from 'Lib/axios'
import { useMutation } from '@tanstack/react-query'

type AddCeParamsType = {
  accountId: number
  domainId: number
  token: string
  gtmAccountId: string
  gtmContainerId: string
  publish: boolean
}

const addCeTag = async (params: AddCeParamsType): Promise<boolean | Error> => {
  return await request({
    url: `accounts/${params.accountId}/google-tag-manager/add-tag`,
    method: 'POST',
    data: {
      token: params.token,
      domainId: params.domainId,
      gtmAccountId: params.gtmAccountId,
      gtmContainerId: params.gtmContainerId,
      publish: params.publish,
    },
    hideErrorToaster: true,
  })
}

export const useAddTag = () => {
  return useMutation(addCeTag)
}
